export const normalizeLang = (lang) => {
    if (!lang) return "en";
    if (lang === "gr") return "el";
    return lang;
};

export const pickLocalized = (obj, baseKey, lang) => {
    if (!obj) return "";
    const l = normalizeLang(lang);

    const exact = obj?.[`${baseKey}_${l}`];
    if (exact) return exact;

    // fallback σειρά (premium safe)
    return (
        obj?.[`${baseKey}_en`] ||
        obj?.[`${baseKey}_el`] ||
        obj?.[baseKey] || // αν κάποτε γυρίσει name σκέτο
        ""
    );
};
